import {ApiError} from 'client';
import {OpenAPI} from 'client/core/OpenAPI';
import {request as __request} from 'client/core/request';

export type PaperPreviewResponse = {
  title: string;
  revision: string;
  mime_type: string;
  content: string;
};

export const buildDropboxPaperUrl = (pathname: string, search: string): string =>
  `https://www.dropbox.com${pathname}${search}`;

const fetchPaperPreviewEndpoint = (url: string): Promise<PaperPreviewResponse> =>
  __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/paper/preview',
    body: {url},
    mediaType: 'application/json',
    errors: {
      400: 'Unsupported Paper URL',
      404: 'Paper document unavailable',
      422: 'Validation Error',
    },
  }) as Promise<PaperPreviewResponse>;

const fetchAdminDebugExport = (url: string): Promise<PaperPreviewResponse> =>
  __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/admin/workstream-importer/debug',
    body: {doc_url: url},
    mediaType: 'application/json',
  }) as Promise<PaperPreviewResponse>;

export const fetchPaperPreview = async (url: string): Promise<PaperPreviewResponse> => {
  try {
    return await fetchPaperPreviewEndpoint(url);
  } catch (error) {
    // Toyon runs the web preview against staging, where a new backend route is
    // unavailable until the API deploys. Let user-admins exercise the viewer
    // locally through the existing read-only Paper export endpoint.
    const isLocalPreview = ['localhost', '127.0.0.1'].includes(window.location.hostname);
    if (!isLocalPreview || !(error instanceof ApiError) || error.status !== 404) {
      throw error;
    }
    return fetchAdminDebugExport(url);
  }
};
